import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=53bfcb7f&"
import script from "./LayoutBase.js?vue&type=script&lang=js&"
export * from "./LayoutBase.js?vue&type=script&lang=js&"
import style0 from "./LayoutBase.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports